import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';
import fetch from 'cross-fetch';
import { resolveRoute } from './router';
var errorLink = onError(function (_a) {
    var forward = _a.forward, graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, operation = _a.operation;
    if (graphQLErrors !== undefined) {
        graphQLErrors.forEach(function (_a) {
            var locations = _a.locations, message = _a.message;
            Sentry.captureException(new Error("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(JSON.stringify(locations))), {
                tags: {
                    errorType: 'graphql',
                    operationName: operation.operationName,
                },
            });
        });
    }
    if (networkError != null) {
        Sentry.captureException(new Error("[Network error]: ".concat(networkError.message)), {
            tags: {
                errorType: 'network',
                operationName: operation.operationName,
            },
        });
    }
    // this will continue to load the component
    forward(operation);
});
var httpLink = new BatchHttpLink({
    batchInterval: 20,
    batchMax: 5,
    credentials: 'include',
    fetch: fetch,
    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
    },
    uri: resolveRoute('graphql'),
});
var link = ApolloLink.from([errorLink, httpLink]);
export var apolloClient = new ApolloClient({
    cache: new InMemoryCache(),
    link: link,
});
